import PropTypes from 'prop-types';
import YachtInterpolatedDescription from './YachtInterpolatedDescription';

const YachtAutomaticDescription = ({ text, professionalsMap }) => {
  if (!text) {
    return null;
  }

  const professionalIds = [
    ...new Set([...text.matchAll(/\{\{professional:[0-9]+\}\}/g)].map(found => found[0]))
  ].map(el => el.replace('{{professional:', '').replace('}}', ''));

  return (
    <YachtInterpolatedDescription
      professionalIds={professionalIds}
      text={text}
      professionalsMap={professionalsMap}
    />
  );
};

YachtAutomaticDescription.propTypes = {
  text: PropTypes.string.isRequired,
  professionalsMap: PropTypes.object.isRequired
};

export default YachtAutomaticDescription;
